import React from 'react';
import useEventListener from '../../hooks/useEventListener';
import { ListConfig, ContentConfig, List, Item } from './styles';
import { userLogout } from '../../store/user';
import { useDispatch } from 'react-redux';

export default function Config({ show = false, onShow = () => null }) {
  const dispatch = useDispatch();
  const configRef = React.useRef();

  const handleSubmit = (e) => {
    e.preventDefault();
    const confirm = window.confirm('Você realmente deseja sair?');
    if (confirm) {
      onShow();
      dispatch(userLogout());
    }
  };

  useEventListener('mousedown', (event) => {
    if (event.defaultPrevented) return;
    if (configRef?.current === event.target) onShow();
  });

  return (
    show && (
      <ContentConfig ref={configRef}>
        <ListConfig>
          <List>
            {/* <Item
              title="Configurações"
              onClick={() => onShow()}
              to="/dashboard/settings"
            >
              CONFIGURAÇÕES
            </Item> */}
            <Item title="Sair" to="/" onClick={handleSubmit}>
              SAIR
            </Item>
          </List>
        </ListConfig>
      </ContentConfig>
    )
  );
}
